import { LinkButton } from "@tokenterminal/core/ui/button/LinkButton"
import { Card } from "@tokenterminal/core/ui/layout/card/Card"

const ApplicationCTA = ({
  title,
  email = "people@tokenterminal.xyz",
  role,
}: {
  title?: string
  email?: string
  role?: string
}) => (
  <Card className="p-7 mt-10 rounded-2xl">
    <div className="flex justify-between w-full">
      <div className="flex flex-col gap-1">
        <p className="font-medium text-fg-default my-0">{title || `Interested in this role?`}</p>
        <p className="text-sm text-fg-secondary my-0">
          Email our people team and we will reach out with next steps.
        </p>
      </div>
      <LinkButton
        href={`mailto:${email}?subject=Interested in ${role || "a"} Role at Token Terminal`}
        variant="solid"
        className="inline-flex no-underline"
      >
        Reach out to our team
      </LinkButton>
    </div>
  </Card>
)

export default ApplicationCTA
